import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "alert alert-success alert-dismissible",
  role: "alert"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Successfully ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "aria-label": "Close"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "card mb-4" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "input-group" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  class: "form-control w-25",
  placeholder: "Enter Search Key !"
}, null, -1)
const _hoisted_11 = {
  type: "button",
  class: "btn btn-primary me-1 ms-1"
}
const _hoisted_12 = {
  type: "button",
  class: "btn btn-default border"
}
const _hoisted_13 = { class: "card mb-4 d-none d-md-block" }
const _hoisted_14 = { class: "card-body" }
const _hoisted_15 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_19 = {
  key: 0,
  class: "table card-table text-center"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Id"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Category"),
    /*#__PURE__*/_createElementVNode("th", null, "Quantity"),
    /*#__PURE__*/_createElementVNode("th", null, "Unit"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1)
const _hoisted_21 = { class: "table-border-bottom-0" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { key: 1 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h5", { class: "text-center mb-0" }, "Please Add Some Product First", -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { class: "mobile-view d-block d-md-none" }
const _hoisted_30 = {
  key: 0,
  class: "card"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center align-items-center" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "spinner-border text-primary",
      role: "status"
    }, [
      /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
    ])
  ])
], -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "card-body" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_36 = { class: "mb-0" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Quantity: ")
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { key: 2 }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "text-center mb-0" }, "Please Add Some Product First")
  ])
], -1)
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = {
  key: 1,
  class: "card"
}
const _hoisted_46 = { class: "card-body d-flex justify-content-around flex-wrap" }
const _hoisted_47 = { "aria-label": "Page navigation" }
const _hoisted_48 = { class: "pagination flex-wrap" }
const _hoisted_49 = ["onClick", "innerHTML"]
const _hoisted_50 = { class: "row" }
const _hoisted_51 = { class: "col-12" }
const _hoisted_52 = { class: "input-group" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", {
  class: "input-group-text",
  for: "inputGroupSelect01"
}, "Size", -1)
const _hoisted_54 = /*#__PURE__*/_createStaticVNode("<option value=\"10\">10</option><option value=\"20\">20</option><option value=\"30\">30</option><option value=\"40\">40</option><option value=\"50\">50</option><option value=\"100\">100</option>", 6)
const _hoisted_60 = [
  _hoisted_54
]
const _hoisted_61 = {
  class: "modal fade",
  id: "modalCenter",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_62 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_63 = { class: "modal-content" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title text-center",
    id: "modalCenterTitle"
  }, "Add Stock"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_65 = { class: "modal-body" }
const _hoisted_66 = { class: "row mb-3" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-sm-12 col-form-label",
  for: "basic-icon-default-store"
}, "Quantity ", -1)
const _hoisted_68 = { class: "col-sm-12" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "modal-footer text-center justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-outline-secondary",
    "data-bs-dismiss": "modal",
    id: "close"
  }, " Close "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn btn-primary"
  }, "Confirm")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.successReport)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _hoisted_10,
            _createElementVNode("button", _hoisted_11, [
              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'magnifying-glass'] })
            ]),
            _createElementVNode("button", _hoisted_12, [
              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'broom'] })
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
          : (_openBlock(), _createElementBlock("div", _hoisted_18, [
              (_ctx.fettchDataArray.length > 0)
                ? (_openBlock(), _createElementBlock("table", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("tbody", _hoisted_21, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fettchDataArray, (dataItem, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: dataItem.id
                        }, [
                          _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                          _createElementVNode("td", null, _toDisplayString(dataItem.name), 1),
                          _createElementVNode("td", null, _toDisplayString(dataItem.category.name), 1),
                          _createElementVNode("td", null, [
                            (dataItem.stocks[0]?.total_quantity )
                              ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(dataItem.stocks[0]?.total_quantity), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_23, "00"))
                          ]),
                          _createElementVNode("td", null, _toDisplayString(dataItem.unit), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "me-2 btn btn-sm btn-primary btn-disable",
                              onClick: ($event: any) => (_ctx.fetchItem(dataItem)),
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#modalCenter"
                            }, " + Add Stock ", 8, _hoisted_24),
                            _createElementVNode("button", {
                              type: "button",
                              class: "me-2 btn btn-sm btn-secondary btn-disable",
                              onClick: ($event: any) => (_ctx.summaryFunc(dataItem.id.toString()))
                            }, " Summary ", 8, _hoisted_25)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
            ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_32))
        : _createCommentVNode("", true),
      (_ctx.fettchDataArray.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fettchDataArray, (dataItem) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "card mb-4",
                key: dataItem.id
              }, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("strong", null, " Name: " + _toDisplayString(dataItem.name), 1),
                  _hoisted_35,
                  _createElementVNode("p", _hoisted_36, "Category: " + _toDisplayString(dataItem.category.name), 1),
                  _createElementVNode("p", null, [
                    _hoisted_37,
                    (dataItem.stocks[0]?.total_quantity)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(dataItem?.stocks[0]?.total_quantity), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_39, "00"))
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "me-2 btn btn-sm btn-primary btn-disable",
                    onClick: ($event: any) => (_ctx.fetchItem(dataItem)),
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#modalCenter"
                  }, " + Add Stock ", 8, _hoisted_40),
                  _createElementVNode("button", {
                    type: "button",
                    class: "me-2 btn btn-sm btn-secondary btn-disable",
                    onClick: ($event: any) => (_ctx.summaryFunc(dataItem.id.toString()))
                  }, " Summary ", 8, _hoisted_41)
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_42, _hoisted_44))
    ]),
    (_ctx.fettchDataArray.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("nav", _hoisted_47, [
              _createElementVNode("ul", _hoisted_48, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginationData.links, (page, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    class: _normalizeClass(["page-item myPagination m-1", { active: page.active }])
                  }, [
                    _createElementVNode("button", {
                      class: "page-link",
                      onClick: ($event: any) => (_ctx.goToPage(Number(page.label))),
                      innerHTML: page.label
                    }, null, 8, _hoisted_49)
                  ], 2))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _hoisted_53,
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    id: "inputGroupSelect01",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pageSize) = $event)),
                    onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fetchData && _ctx.fetchData(...args)))
                  }, _hoisted_60, 544), [
                    [_vModelSelect, _ctx.pageSize]
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_61, [
      _createElementVNode("div", _hoisted_62, [
        _createElementVNode("div", _hoisted_63, [
          _hoisted_64,
          _createElementVNode("form", {
            name: "",
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("div", _hoisted_66, [
                _hoisted_67,
                _createElementVNode("div", _hoisted_68, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "basic-icon-default-fullname",
                    placeholder: "Quantity",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.addstock.quantity) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.addstock.quantity]
                  ])
                ])
              ])
            ]),
            _hoisted_69
          ], 32)
        ])
      ])
    ])
  ]))
}